import { useCallback, useEffect, useState } from 'react';

/**
 * Open state for the command palette, plus the Cmd/Ctrl+K binding.
 *
 * The listener is registered once at the layout level rather than per page, so
 * the shortcut works everywhere inside the dashboard.
 */
export const useCommandPalette = () => {
    const [open, setOpen] = useState(false);

    const close = useCallback(() => setOpen(false), []);
    const toggle = useCallback(() => setOpen((value) => !value), []);

    useEffect(() => {
        const onKeyDown = (event) => {
            if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
                // Chrome binds Ctrl+K to the address bar; claim it first.
                event.preventDefault();
                setOpen((value) => !value);
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    return { open, close, toggle };
};

/** True on Apple platforms, where the shortcut hint should read ⌘K not Ctrl+K. */
export const isAppleDevice = () =>
    typeof navigator !== 'undefined' &&
    /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
